module.exports = __webpack_public_path__ + "static/media/gif_atendimentos.3c1b6e60.gif";